import React from 'react';

import { App } from '@flipdish/api-client-typescript';
import { Button } from '@flipdish/ui-library/components/atoms/Button';
import { Translate } from 'react-localize-redux';
import { connect } from 'react-redux';
import Permissions from 'react-redux-permissions';
import { compose } from 'recompose';

import { getEditAccountUrlFactory } from '../../../banking.selectors';

type OuterProps = {
  accountId: number;
};

type MappedProps = ReturnType<ReturnType<typeof mapStateToPropsFactory>>;
type Props = OuterProps & MappedProps;

const EditAccountButtonInner = ({ editAccountUrl }: Props) => {
  if (!editAccountUrl) {
    return null;
  }

  return (
    <Permissions allowed={[App.AppResourceSetEnum.CreateBankAccounts]}>
      <Button color="primary" size="md" href={editAccountUrl}>
        <Translate id="Edit" />
      </Button>
    </Permissions>
  );
};

const mapStateToPropsFactory = (state: AppState, ownProps: OuterProps) => {
  const getEditAccountUrl = getEditAccountUrlFactory(ownProps.accountId);
  return (state: AppState) => ({
    editAccountUrl: getEditAccountUrl(state),
  });
};

export default compose<MappedProps, OuterProps>(connect(mapStateToPropsFactory))(
  EditAccountButtonInner
);
